module.exports = __webpack_public_path__ + "static/media/ic_fin_tools_fhc.fe58a1a7.svg";